"use client";

import { useState } from "react";
import { useLanguage } from "../../contexts/LanguageContext";
import { Band, SectionHead } from "../ui/Section";
import Reveal from "../ui/Reveal";
import Icon from "../ui/Icon";
import VideoModal from "../VideoModal";

const MANAGEMENT_URL = "https://management.cosebu.com/";

const Management = () => {
  const { t } = useLanguage();
  const [videoOpen, setVideoOpen] = useState(false);

  const featureIcons = ["box", "users", "chart", "card", "device"];

  return (
    <Band id="management">
      <SectionHead
        index={2}
        label={t.management.eyebrow}
        title={t.management.title}
        action={
          <div className="flex flex-wrap items-center gap-3">
            <a
              href={MANAGEMENT_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn--primary"
            >
              {t.management.tryProduct}
              <Icon name="arrowUpRight" size={16} />
            </a>
            <button
              type="button"
              onClick={() => setVideoOpen(true)}
              className="btn btn--secondary"
            >
              <Icon name="play" size={14} />
              {t.management.watchDemo}
            </button>
          </div>
        }
      >
        {t.management.description}
      </SectionHead>

      <div className="rail">
        <div className="rail__label" aria-hidden="true" />

        <div className="grid gap-10 lg:grid-cols-12 lg:gap-14">
          {/* Screenshot in a restrained frame — chrome, not decoration. */}
          <Reveal className="lg:col-span-7">
            <figure className="panel overflow-hidden">
              <figcaption className="flex items-center gap-2 border-b border-line px-3 py-2.5">
                <span className="h-2 w-2 rounded-full bg-line-strong" />
                <span className="h-2 w-2 rounded-full bg-line-strong" />
                <span className="h-2 w-2 rounded-full bg-line-strong" />
                <span className="num ml-2 truncate text-[11px] text-ink-3">
                  management.cosebu.com
                </span>
              </figcaption>
              <img
                src="/cosebu-management.png"
                alt={`${t.management.title} — dashboard`}
                loading="lazy"
                className="w-full"
              />
            </figure>
          </Reveal>

          {/* Capability list — ruled rows, one icon language. */}
          <div className="lg:col-span-5">
            <Reveal>
              <span className="tag tag--live">
                <span className="dot" />
                {t.management.availableIn}
              </span>
            </Reveal>

            <ul className="mt-6 divide-rule border-t border-line">
              {t.management.features.map((feature, index) => (
                <Reveal
                  as="li"
                  key={feature}
                  delay={index * 0.04}
                  className="flex items-center gap-3.5 py-4"
                >
                  <Icon name={featureIcons[index]} size={18} className="flex-none text-accent" />
                  <span className="text-[15px]">{feature}</span>
                </Reveal>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <VideoModal
        isOpen={videoOpen}
        onClose={() => setVideoOpen(false)}
        title={`${t.management.title} — ${t.management.watchDemo}`}
      />
    </Band>
  );
};

export default Management;
